import React from 'react';
import './PatioDoorSelectorModal.css';
import { useNavigate } from 'react-router-dom';

const PatioDoorSelectorModal = ({ isOpen, onClose, quoteId, fkCustomerId, fkUserId, viewItem }) => {
  const navigate = useNavigate();

  const handleSelect = (doorType) => {
    onClose();
    navigate(`/patiodoors/pdt/${doorType}`, {
      state: { quoteId, fkCustomerId, fkUserId, viewItem },
    });
  };

  if (!isOpen) return null;

  // Patio door configurations
  const patioDoors = [
    { id: 'pd1', image: 'double_sliding_door.png', label: '2-Panel Sliding', description: '72" x 80"' },
    { id: 'pd2', image: 'triple_sliding_door.png', label: '3-Panel Sliding', description: '96" x 80"' },
    { id: 'pd3', image: 'quad_sliding_door.png', label: '4-Panel Sliding', description: '120" x 80"' },
  ];

  return (
    <div className="pd-modal-backdrop" onClick={onClose}>
      <div className="pd-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="pd-close-button" onClick={onClose}>×</button>
        <h2 className="pd-modal-title">Select Patio Door Configuration</h2>

        <div className="pd-image-grid">
          {patioDoors.map((door) => (
            <div
              key={door.id}
              className="pd-door-card"
              onClick={() => handleSelect(door.id)}
            >
              <img
                src={`/images/patiodoors/${door.image}`}
                alt={door.label}
              />
              <div className="pd-door-label">{door.label}</div>
              <div className="pd-door-description">{door.description}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PatioDoorSelectorModal;
